import { createPortal } from 'react-dom'
import React, { FC } from 'react'

import { AnimatePresence, motion } from 'framer-motion'
import { useLockBodyScroll } from 'react-use'

interface Props {
  isVisible: boolean
}

const Overlay: FC<Props> = ({ isVisible, children }) => {
  // useLockBodyScroll(isVisible)

  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="overlay">
          {children}
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}

export default Overlay
